export function initTabs() {
  const tabs = document.querySelectorAll(".possibilities__tab");
  const tabContents = document.querySelectorAll(".possibilities__description");

  if (!tabContents.length) return;

  tabs.length &&
    tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => {
        tabs.forEach(t => t.classList.remove("possibilities__tab_active"));
        tab.classList.add("possibilities__tab_active");
        const tabId = tab.getAttribute("data-id");

        tabContents.forEach(content => (content.style.display = "none"));

        tabContents.forEach(content => {
          if (content.getAttribute("data-content") === tabId) {
            content.style.display = "flex";
          }
        });
      });
    });
}

export function filterTabsContent(content, activeTabKey) {
  if (!content || !activeTabKey) {
    return;
  }

  const contentKey = content.getAttribute("data-tab-value");

  if (contentKey === activeTabKey) {
    content.style.display = "flex";
  } else {
    content.style.display = "none";
  }
}

export function initTabsAll() {
  const tabsBlocks = document.querySelectorAll(".tabsBlock");

  if (!tabsBlocks.length) return;

  tabsBlocks.forEach(tabBlock => {
    const tabContents = tabBlock.querySelectorAll("[data-tab-value]");
    const tabs = tabBlock.querySelectorAll(".tab");
    const activeTab = tabBlock.querySelector(".activeTab");
    const activeTabKey = activeTab?.getAttribute("data-tab-key");

    //фильтруем табы по умолчанию (при загрузке страницы)
    tabContents.forEach(content => {
      filterTabsContent(content, activeTabKey);
    });

    tabs.forEach(tab => {
      tab.addEventListener("click", () => {
        tabs.forEach(t => t.classList.remove("activeTab"));
        tab.classList.add("activeTab");

        const activeTabKey = tab.getAttribute("data-tab-key");

        //если нет активного таба, то отображаем все элементы
        if (!activeTabKey) {
          tabContents.forEach(content => {
            content.style.display = "flex";
          });
          return;
        }

        //если есть активны таб, то фильтруем элементы
        tabContents.forEach(content => {
          filterTabsContent(content, activeTabKey);
        });
      });
    });
  });
}
